import KeyValueTableFilledTextTextValue from './KeyValueTableFilledTextTextValue';
import { KeyValueTableFilledTextTextValueProps, KeyValueTableFilledTextTextValueValueProps } from './types';

export type { KeyValueTableFilledTextTextValueProps, KeyValueTableFilledTextTextValueValueProps };
export default KeyValueTableFilledTextTextValue;
